import React, { useState, useEffect, useRef } from 'react';
import { Box, Button } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import { useForm } from 'react-hook-form';
import { history, useLocation } from 'umi';
import { useDispatch, useSelector } from 'dva';
import AddIcon from '@material-ui/icons/Add';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import TitleML from './components/TitleML';
import BasicML from '../components/BasicML';
import DetailML from './components/DetailML';
import Loading from '@/components/LoadingML/LoadingML';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import webStorage from '@/utils/storageManager';
import CollectionLabelStyled from './CollectionLabelStyles';

const creatId = () => {
  return Math.random().toString(36).substr(2, 10);
};

const creatObj = () => {
  return {
    id: creatId(),
    operation: null, // 标签规则运算符, > < =
    operationValue: null, // 标签运算需要的数值 > < = 对应的值
    operationAnd: null, // 标签运算符，'计算类型为，相对的时候所用' 过去、将来、至过去等
    operationAndValue: null, // 标签运算符，'计算类型为，相对的时候所用' 过去、将来、至过去等对应的值
    operationType: null, // 标签运算类型 1-绝对的 2-相对的 3-有值 4-无值
    outsideSort: null, //用于排序
    profileTagCollectionId: null, //集合标签单中个标签物理ID
    profileTagId: null, // 标签物理ID
    type: null, //标签规则类型 1-包含 2-排除
    valueFieldIds: null, // 标签规则所选字段ID
    valueType: null, // 类型 1-文本输入 2-下拉框 3-日期类型 4-日期时间类型
    withinSort: null, // 标签规则'且'集合的排序
  };
};
//初始化详细设定数据结构
const initDetailForm = () => {
  return {
    id: creatId(),
    name: '', //集合标签的集合名称
    nameEn: null, //集合标签的集合英文名称
    remark: '', //集合标签的集合备注名称
    type: 1,
    tagCollectionRuleIn: [
      {
        outsideSort: null,
        id: creatId(),
        withinItem: [creatObj()],
      },
    ],
    tagCollectionRuleOut: [],
  };
};

const initValueFieldIds = (ids, list) => {
  let data = [];
  const init = (pIds, pList) => {
    if (pIds.length > 0) {
      for (let i = 0; i < pIds.length; i++) {
        const d = pList.find((item) => item.id === pIds[i]);
        if (d) {
          data.push(d);
          const fIds = pIds.filter((it) => it !== pIds[i]);
          fIds.length > 0 && init(fIds, d.children);
          break;
        }
      }
    }
  };
  init(ids, list);
  return data;
};

export default () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { query } = location;
  const queryType = query?.opt;
  const tagId = query.tagId ? Number(query.tagId) : null;
  const sourceOid = query.sourceOid;
  const [tagCollectionInfo, setTagCollectionInfo] = useState(null);
  const [deleteIds, setDeleteIds] = useState([]); //删除的id
  const [submitStatus, setSubmitStatus] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [saveOpen, setSaveOpen] = useState({
    tips: '',
    status: false,
    title: '',
  });
  const submitRef = useRef();
  const { ruleLabelDirectoryList } = useSelector((state) => state.labelManage);
  const {
    handleSubmit,
    control,
    errors,
    getValues,
    setValue,
    setError,
    clearErrors,
  } = useForm();
  // 用户菜单权限
  const userAuths = webStorage.get('USER')?.authorities;
  const loadingEffect = useSelector((state) => state.loading);
  const loading =
    loadingEffect.effects['labelManage/getQueryCollectionTagInfo'];
  const handleClickOpen = () => {
    if (queryType === 'detail') {
      history.goBack();
      return;
    }
    setSaveOpen({
      status: true,
      tips: '退出后将不保存设置内容，确定要退出吗？',
      title: '退出',
    });
  };

  const onSubmitError = () => {
    setSubmitStatus(true);
    window.message.toast({
      type: 'error',
      message: '输入有误',
    });
  };

  const onSubmitSuccess = (data) => {
    if (!submitStatus) {
      return;
    }
    setIsLoading(true);
    setSubmitStatus(false);
    const postData = {};
    postData.id = tagId ? tagId : null;
    postData.name = data.name;
    postData.nameEn = '';
    postData.pid = data.pid;
    postData.remark = data.remark;
    postData.remark = data.remark;
    postData.ruleType = 1;
    postData.source = 1;
    postData.type = 1;
    postData.status = data.status;
    postData.updateStrategy = Number(data.updateStrategy);
    const newTagCollectionInfo = JSON.parse(JSON.stringify(tagCollectionInfo));
    newTagCollectionInfo.forEach((item) => {
      let tagCollectionRule = [];
      if (item.tagCollectionRuleIn) {
        item.tagCollectionRuleIn.forEach((it) => {
          delete it.id;
          it.withinItem.forEach((i) => {
            if (!tagId || typeof i.id !== 'number') {
              i.id = null;
            }
            i.operationAnd = i.operationAnd ? i.operationAnd : null;
            i.valueFieldIds = i.valueFieldIds.map((x) => x.id);
          });
        });
        const inData = {
          type: 1,
          tagRuleOutsideData: item.tagCollectionRuleIn,
        };
        tagCollectionRule.push(inData);
      }
      if (item.tagCollectionRuleOut) {
        item.tagCollectionRuleOut.forEach((it) => {
          delete it.id;
          it.withinItem.forEach((i) => {
            if (!tagId || typeof i.id !== 'number') {
              i.id = null;
            }
            i.operationAnd = i.operationAnd ? i.operationAnd : null;
            i.valueFieldIds = i.valueFieldIds.map((x) => x.id);
          });
        });
        const outData = {
          type: 2,
          tagRuleOutsideData: item.tagCollectionRuleOut,
        };
        tagCollectionRule.push(outData);
      } else {
        const outData = {
          type: 2,
          tagRuleOutsideData: [],
        };
        tagCollectionRule.push(outData);
      }
      if (!tagId || typeof item.id !== 'number') {
        item.id = null;
      }
      delete item.tagCollectionRuleOut;
      delete item.tagCollectionRuleIn;

      item.tagCollectionRule = tagCollectionRule;
    });
    postData.tagCollectionInfo = newTagCollectionInfo;
    postData.deleteTagCollectionIds = deleteIds;
    window.NE_DAWN.trigger(submitRef.current, {
      event: '_ec', // 事件名
      params: { ...postData }, // 事件公参
    });
    dispatch({
      type: 'labelManage/postInsertOrUpdateTagAndCollectionAndRule',
      payload: {
        values: postData,
      },
      callback: (code) => {
        if (code === 0) {
          window.message.toast({
            type: 'success',
            message: !tagId ? '保存集合类标签成功' : '修改集合类标签成功',
            title: '成功',
          });
          history.goBack();
        }
      },
    });
  };
  useEffect(() => {
    !tagId && setTagCollectionInfo([initDetailForm()]);
    !tagId && setValue('updateStrategy', '1');
    !tagId && setValue('status', '2');
  }, [setValue, tagId]);
  useEffect(() => {
    dispatch({
      type: 'labelManage/getQueryTagTreeCL',
      payload: {
        values: {},
      },
    });
  }, [dispatch]);
  useEffect(() => {
    const fetch = async () => {
      let directoryList = null;
      await dispatch({
        type: 'labelManage/getQueryFileList',
        payload: {
          values: {},
        },
        callback: (list) => {
          directoryList = list;
        },
      });
      if (tagId) {
        await dispatch({
          type: 'labelManage/getQueryCollectionTagInfo',
          payload: {
            values: {
              tagId,
            },
          },
          callback: (data) => {
            const newData = JSON.parse(JSON.stringify(data));
            const updateStrategy = String(newData.updateStrategy);
            setValue('name', newData.name);
            setValue('pid', newData.pid);
            setValue('updateStrategy', updateStrategy);
            setValue('remark', newData.remark);
            setValue('status', String(newData.status));
            if (newData.tagCollectionInfo.length > 0) {
              newData.tagCollectionInfo.forEach((item) => {
                if (item.tagCollectionRule) {
                  let tagCollectionRuleIn = [];
                  let tagCollectionRuleOut = [];
                  item.tagCollectionRule.forEach((it) => {
                    it.tagRuleOutsideData.forEach((x) => {
                      x.withinItem.forEach((y) => {
                        y.valueFieldIds = initValueFieldIds(
                          y.valueFieldIds,
                          directoryList,
                        );
                      });
                    });
                    if (it.type === 1) {
                      tagCollectionRuleIn = it.tagRuleOutsideData.map((i) => {
                        return { ...i, id: creatId() };
                      });
                    } else {
                      tagCollectionRuleOut = it.tagRuleOutsideData.map((i) => {
                        return { ...i, id: creatId() };
                      });
                    }
                  });
                  item.tagCollectionRuleIn = tagCollectionRuleIn;
                  item.tagCollectionRuleOut = tagCollectionRuleOut;
                  delete item.tagCollectionRule;
                }
              });
            }
            setTagCollectionInfo(newData.tagCollectionInfo);
          },
        });
      }
    };
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, tagId]);

  //点击新增一条集合，最外层的新增按钮
  const handleAddCollectionlData = () => {
    tagCollectionInfo.push(initDetailForm());
    setTagCollectionInfo([...tagCollectionInfo]);
  };

  //点击新增一条详细设置
  const handleAddRuleData = ({ id, type }) => {
    tagCollectionInfo.forEach((item) => {
      if (item.id === id) {
        if (type) {
          item.tagCollectionRuleIn.push({
            outsideSort: '',
            id: creatId(),
            withinItem: [creatObj()],
          });
        } else {
          item.tagCollectionRuleOut.push({
            outsideSort: '',
            id: creatId(),
            withinItem: [creatObj()],
          });
        }
        return;
      }
    });
    setTagCollectionInfo([...tagCollectionInfo]);
  };
  //点击新增一条详细设置的删除
  const handleAddRuleDataDelete = ({ id, type, selfId }) => {
    tagCollectionInfo.forEach((item) => {
      if (item.id === id) {
        if (type) {
          const newData = item.tagCollectionRuleIn.filter(
            (it) => selfId !== it.id,
          );
          item.tagCollectionRuleIn = newData;
        } else {
          const newData = item.tagCollectionRuleOut.filter(
            (it) => selfId !== it.id,
          );
          item.tagCollectionRuleOut = newData;
        }
      }
    });
    setTagCollectionInfo([...tagCollectionInfo]);
  };

  //点击新增一条详细规则设置， type===true是满足，
  const handleAddRuleDetailData = ({ id, pid, type }) => {
    tagCollectionInfo.forEach((item) => {
      if (item.id === pid) {
        const data = type
          ? item.tagCollectionRuleIn
          : item.tagCollectionRuleOut;
        data.forEach((it) => {
          if (it.id === id) {
            it.withinItem.push(creatObj());
          }
          return;
        });
        return;
      }
    });
    setTagCollectionInfo([...tagCollectionInfo]);
  };

  //点击新增一条详细规则设置删除，type===true是满足， selfId最里面行id，wid框id，pid详细设定id,
  const handleAddRuleDetailDataDelete = ({ wid, selfId, pid, type }) => {
    tagCollectionInfo.forEach((item) => {
      if (item.id === pid) {
        const data = type
          ? item.tagCollectionRuleIn
          : item.tagCollectionRuleOut;
        data.forEach((it) => {
          if (it.id === wid) {
            const newWithinItem = it.withinItem.filter((i) => i.id !== selfId);
            it.withinItem = newWithinItem;
          }
          return;
        });
        return;
      }
    });
    setTagCollectionInfo([...tagCollectionInfo]);
  };

  const setFieldValue = (parameter) => {
    const { wid, selfId, pid, type, value, realName, id } = parameter;
    tagCollectionInfo.forEach((item) => {
      if (item.id === id) {
        item[realName] = value;
        return;
      }
      if (item.id === pid) {
        const data = type
          ? item.tagCollectionRuleIn
          : item.tagCollectionRuleOut;
        data.forEach((it) => {
          if (it.id === wid) {
            it.withinItem.forEach((eIt) => {
              if (eIt.id === selfId) {
                eIt[realName] = value;
                return;
              }
            });
          }
          return;
        });
        return;
      }
    });
    setTagCollectionInfo(tagCollectionInfo);
  };

  //删除最外层的卡片
  const handleDetailDelete = ({ id }) => {
    const newTagCollectionInfo = tagCollectionInfo.filter(
      (item) => item.id !== id,
    );
    if (typeof id === 'number') {
      deleteIds.push(id);
      setDeleteIds(deleteIds);
    }
    setTagCollectionInfo([...newTagCollectionInfo]);
  };
  //重置详细设置
  const handleRefreshDetail = ({ id }) => {
    tagCollectionInfo.forEach((item) => {
      if (item.id === id) {
        item.name = '';
        item.nameEn = null;
        item.remark = '';
        item.tagCollectionRuleIn = [
          {
            outsideSort: null,
            id: creatId(),
            withinItem: [creatObj()],
          },
        ];
        item.tagCollectionRuleOut = [];
      }
    });
    setTagCollectionInfo([...tagCollectionInfo]);
  };

  const handleSubmitData = () => {
    // setOpenError(true);
    setSaveOpen({
      status: true,
      tips: '确认保存当前所创建的内容？',
      title: '保存',
    });
  };
  //新建标签自定义按钮
  const initButton = () => {
    const buttonNode = (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '0 16px',
          width: '100%',
          marginBottom: '24px',
          marginRight: '24px',
        }}
      >
        <Button
          sx={{
            width: '100px!important',
          }}
          variant="contained"
          onClick={onCloseDialog}
          color="secondary"
        >
          取消
        </Button>
        <Button
          sx={{ width: '100px!important' }}
          variant="contained"
          onClick={onSaveLabelDialog}
        >
          确定
        </Button>
      </Box>
    );
    return { buttonNode, isShow: true, height: 'auto' };
  };

  const onSaveLabelDialog = () => {
    setSaveOpen({
      ...saveOpen,
      status: false,
    });
    if (saveOpen.title === '保存') {
      submitRef.current.click();
    } else if (saveOpen.title === '退出') {
      history.goBack();
    } else {
      dispatch({
        type: 'labelManage/deleteLabel',
        payload: {
          values: {
            tagId,
          },
        },
        callback(res) {
          if (res.code === 0) {
            webStorage.set('DELETE_TAG', tagId);
            window.message.toast({
              type: 'success',
              message: '删除成功',
              title: '删除成功',
            });
            setTimeout(() => {
              history.goBack();
            }, 2000);
          }
        },
      });
    }
  };

  const onCloseDialog = () => {
    setSaveOpen({
      ...saveOpen,
      status: false,
    });
  };

  const handleDelete = () => {
    setSaveOpen({
      status: true,
      tips: `确认删除“${getValues('name')}”标签？删除后将无法复原。`,
      title: '删除',
    });
  };
  return (
    <CollectionLabelStyled>
      <Box
        data-log={JSON.stringify({
          oid: 'page_user_profile_label_management_gather_edit',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
      >
        <Loading loading={loading}>
          <form onSubmit={handleSubmit(onSubmitSuccess, onSubmitError)}>
            <Box borderRadius="12px" bgcolor="background.paper" p={4}>
              <TitleML title="标签基本设置" fontSize="19px" p="0 0 32px 0" />
              <BasicML
                queryType={queryType}
                control={control}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                setError={setError}
                clearErrors={clearErrors}
              />
            </Box>
            <Box
              borderRadius="12px"
              bgcolor="background.paper"
              p={4}
              mt={0.5}
              mb={0.5}
            >
              <TitleML title="标签规则设置" fontSize="19px" p="0" />
            </Box>
            <Box>
              <DetailML
                queryType={queryType}
                control={control}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                tagCollectionInfo={tagCollectionInfo} //详细设置的数据
                setError={setError}
                clearErrors={clearErrors}
                handleAddRuleData={handleAddRuleData}
                handleAddRuleDataDelete={handleAddRuleDataDelete}
                handleAddRuleDetailData={handleAddRuleDetailData}
                handleAddRuleDetailDataDelete={handleAddRuleDetailDataDelete}
                handleDetailDelete={handleDetailDelete}
                handleRefreshDetail={handleRefreshDetail}
                setFieldValue={setFieldValue}
                ruleLabelDirectoryList={ruleLabelDirectoryList} //级联数据
              />
            </Box>
            {queryType !== 'detail' && (
              <Box>
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  sx={{
                    width: '120px',
                    borderRadius: '24px',
                    height: '34px',
                    // background: '#4CAF50',
                    marginTop: '27px',
                    marginBottom: '23px',
                    marginLeft: '31px',
                  }}
                  onClick={handleAddCollectionlData}
                >
                  添加集合
                </Button>
              </Box>
            )}
            <Box
              borderRadius="12px"
              bgcolor="background.paper"
              p={4}
              mt={0.5}
              mb={0.5}
              className="button-wrap"
            >
              {queryType !== 'detail' && (
                <LoadingButton
                  variant="contained"
                  onClick={handleSubmitData}
                  loading={isLoading}
                  loadingPosition="start"
                  startIcon={
                    <DoneIcon sx={{ width: '16px', height: '16px' }} />
                  }
                  sx={{ marginRight: '16px' }}
                >
                  保存
                </LoadingButton>
              )}
              {queryType === 'edit' && (
                <Button
                  data-log={JSON.stringify({
                    oid: 'btn_user_profile_label_management_gather_edit_delete',
                    events: ['_ev'],
                    params: {
                      initUrl:
                        window.location.origin + window.location.pathname,
                      source: sourceOid,
                    },
                  })}
                  style={{
                    marginRight: '15px',
                    backgroundColor:
                      userAuths.indexOf('OPT_PROFILE_TAG_DELETE') > -1
                        ? '#CA2C21'
                        : '#F5F5F5',
                    color:
                      userAuths.indexOf('OPT_PROFILE_TAG_DELETE') > -1
                        ? '#fff'
                        : '#ccc',
                  }}
                  variant="contained"
                  className="cancel"
                  startIcon={
                    <DeleteIcon sx={{ width: '16px', height: '16px' }} />
                  }
                  onClick={
                    userAuths.indexOf('OPT_PROFILE_TAG_DELETE') > -1 &&
                    handleDelete
                  }
                >
                  删除
                </Button>
              )}
              <Button
                variant="contained"
                color="secondary"
                className="cancel"
                startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
                onClick={() => handleClickOpen()}
              >
                退出
              </Button>
            </Box>
            <Button
              data-log={JSON.stringify({
                oid: 'btn_user_profile_label_management_gather_edit_save',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                  source: sourceOid,
                },
              })}
              sx={{ display: 'none' }}
              type="submit"
              ref={submitRef}
            ></Button>
          </form>
        </Loading>
        <DialogDataML
          open={saveOpen.status}
          title={
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <span
                style={{ fontSize: '18px', fontWeight: 600, color: '#212121' }}
              >
                {saveOpen.title}
              </span>
            </Box>
          }
          content={<Box sx={{ width: '336px' }}>{saveOpen.tips}</Box>}
          handleClose={onCloseDialog}
          button={initButton()}
        />
      </Box>
    </CollectionLabelStyled>
  );
};
